import {clsx} from 'clsx';
import {Suspense} from 'react';

import {Spinner} from '../Spinner/Spinner';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  ref?: React.RefObject<HTMLDivElement>;
};
export const SleeveContent = ({ref, children, className, ...props}: Props) => {
  return (
    <div
      ref={ref}
      {...props}
      className={clsx(
        'h-0 flex-1 space-y-6 overflow-y-auto px-4 pb-5 pt-6 sm:px-6',
        className
      )}
    >
      <Suspense fallback={<Spinner padded />}>{children}</Suspense>
    </div>
  );
};

SleeveContent.displayName = 'SleeveContent';
